import store from '@/store'
import { Entity } from '@/store/entity'

export class Refund extends Entity {
  get bankAccount() {
    const bankAccount = store.getters['bankAccounts/getBankAccount'](this.partner_bank_account_id)

    if (!bankAccount || bankAccount.isDefault) {
      store.dispatch('bankAccounts/fetchBankAccount', this.partner_bank_account_id)
    }

    return bankAccount
  }

  get branch() {
    if (this.partner_branch_id === null) {
      return null;
    }

    const branch = store.getters['branchs/getBranch'](this.partner_branch_id)

    if (!branch || branch.isDefault) {
      store.dispatch('branchs/fetchBranch', this.partner_branch_id)
    }

    return branch
  }

  get rescueCodes() {
    return store.getters['refunds/rescueCodes/getRefundRescueCodesByRefundId'](this.id)
  }

  get amountFormatted() {
    return this.formatCurrency(this.amount);
  }

  get paymentAtFormatted() {
    return this.formatDate(this.payment_at);
  }

  get statusLabel() {
    switch (this.status) {
      case 'pending':
        return 'Pendente';
      case 'completed':
        return 'Concluído';
      default:
        return this.status;
    }
  }

  isPending() {
    return this.status === 'pending';
  }

  isCompleted() {
    return this.status === 'completed';
  }
}
